import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import moment from 'moment';
import 'moment/locale/es-mx';
import { Grid, Col, ControlLabel, Button, Panel, Dropdown, Icon, DatePicker, IntlProvider } from 'rsuite';
import esES from 'rsuite/lib/IntlProvider/locales/es_ES';
import enUS from 'rsuite/lib/IntlProvider/locales/en_US';
import dateFnsFormat from 'date-fns/format';
import dateFnsEsLocale from 'date-fns/locale/es';
import Layout from '../../../components/Layout';
import TableList from '../../../components/TableList';
import Swal from 'sweetalert2';
import $ from 'jquery';
import ModalMap from '../ModalMap';
import { fileDownLoad } from '../../../lib/fetchRequest';

class Visit extends Component{
    constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.search = this.search.bind(this);
        this.updateColumns = this.updateColumns.bind(this);
        this.actionIcon = this.actionIcon.bind(this);
        this.getLocation = this.getLocation.bind(this);
        this.downloadEvidences = this.downloadEvidences.bind(this);

        this.state = {
            start_date:moment().startOf('month').format('YYYY-MM-DD'),
            end_date:moment().format('YYYY-MM-DD'),
            data:[],
            filename:'visit.name',
            columns:[
                {title:'employee', name:'employee', visible:true, width:'18%'},
                {title:'start_date', name:'start_date', visible:true, width:'12%'},
                {title:'start_location', name:'start_location', visible:true, width:'15%'},
                {title:'end_date', name:'end_date', visible:true, width:'12%'},
                {title:'end_location', name:'end_location', visible:true, width:'15%'},
                {title:'visit_time', name:'visit_time', visible:true, width:'8%'},
                {title:'visitName', name:'visitName', visible:true, width:'14%'},
                {title:'evidence', name:'evidence', visible:true, width:'6%'}
            ],
            list:[],
            visits:[],
            location:"all",
            locations:[],
            userType:'',
            locationId:''
        }
    }

    async componentDidMount(){
        // Igual que Entries.js/CheckInFace.js: search() ya se encarga de
        // (re)inicializar la tabla (resetTable()+setTable()) — llamar
        // setTable() aquí primero solo para reinicializarla otra vez
        // segundos después, sin darle tiempo a fixedColumns de terminar su
        // propio setup diferido, es lo que producía un "Failed to execute
        // 'removeChild'" al destruir/remontar una instancia a medio armar.
        if(this.props.location.state !== undefined){
            await this.setState({
                start_date: this.props.location.state.startDate,
                end_date: this.props.location.state.endDate
            });
        }

        // Mismo idioma para moment que Entries.js/CheckInFace.js — moment
        // usa su propio locale global, independiente del de i18next.
        moment.locale(this.props.i18n.language && this.props.i18n.language.startsWith('en') ? 'en' : 'es-mx');

        await this.GetLocations();

    }

    async GetLocations(){
        var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);

        var locations = await this.props.fetchRequest({
            api:'accounts',
            method:'get',
            url:'locations/by-account/'+accountId,
            obj:null,
            requireToken:true
        });

        if(locations !== undefined){
            this.setState({locations: locations});
        }

        let user = sessionStorage.getItem('userType');
        if (user === 'client') {
            locations.map((l,i) => {
                if (l.id === sessionStorage.getItem('locationId')) {
                    this.setState({
                        location: l.name,
                        userType:'client',
                        locationId:l.id
                    });
                }
            })
        }

        await this.search(null, 'reports/visits-by-account/');
    }


    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    // El DatePicker de rsuite entrega un objeto Date (o null si se limpia),
    // no un string como el <input type="date"> nativo que reemplaza — el
    // resto del componente (search(), el estado) sigue esperando 'YYYY-MM-DD'.
    handleDateChange(name, date){
        if(date){
            this.setState({[name]: moment(date).format('YYYY-MM-DD')});
        }
    }

    async search(e, url){
        $('.rs-btn-default').blur();
        var error = "";

        var obj = {
            startDate: this.state.start_date,
            endDate: this.state.end_date,
            locationId: this.state.locationId
        };

        var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);

        var req = {
            api: 'reports',
            url: 'reports/visits-by-account/'+accountId,
            obj: obj,
            method: 'POST',
            modal: this.props.modal_loader,
            message_modal: this.props.t('modal.spin.searching'),
            requireToken: true
        };

        if(error === ""){
            var request = await this.props.fetchRequest(req);
            var list = [];
            //tipo/icono/color/nombre/accion
            request.map((l)=>
                list.push([
                    l.employee,
                    moment(l.visitStartDate).format('DD/MM/YYYY HH:mm'),
                    l.visitStartLocation !== null && l.visitStartLocation !== ""?
                       'icon/' + l.visitStartLocation + '/#7E7E7E/no_location/one/'+ l.startLatitude+'/'+l.startLongitude
                    : 'icon/map-marker/'+(l.startLatitude !== null && l.startLongitude !== null ?
                        'green/start_location/one/' : '#7E7E7E/no_location/no_action/')+
                        l.startLatitude+'/'+l.startLongitude,
                    moment(l.visitEndDate).format('DD/MM/YYYY HH:mm'),
                    l.visitEndLocation !== null && l.visitEndLocation !== "" ?
                        'icon/' + l.visitEndLocation + '/#7E7E7E/no_location/one/' + l.endLatitude+'/'+l.endLongitude
                        : 'icon/map-marker/'+(l.endLatitude !== null && l.endLongitude !== null ?
                            'green/end_location/one/' : '#7E7E7E/no_location/no_action/')+
                            l.endLatitude+'/'+l.endLongitude,
                    l.visitTime !== null ? l.visitTime : '',
                    l.visitName === "null"?"":l.visitName,
                    "icon/image/"+(l.flagEvidence ? '#2196F3' : '#7E7E7E')+"/evidence/"+(l.flagEvidence ? 'one' : 'no_action')
                ])
            );

            // resetTable()/setTable() corren en el callback de setState,
            // después de que React ya volvió a renderizar el <tbody> con
            // "list" — si no, DataTables puede escanear un render
            // intermedio. Antes esto se cubría con dos setTimeout
            // (500ms/1000ms) que además reabrían el modal de carga a la
            // mitad (parpadeo cerrado→abierto→cerrado) y agregaban ~1s de
            // espera artificial. El setTimeout(…, 0) que queda es distinto:
            // esta tabla usa scrollX + fixedColumns, y la extensión
            // fixedColumns termina su propio armado en un callback diferido
            // después del primer pintado — si resetTable() la destruye
            // antes de que ese callback corra, truena con "Failed to
            // execute 'removeChild'" (mismo bug de Entries.js/CheckInFace.js).
            this.setState({list: list, visits: request}, ()=>{
                setTimeout(()=>{
                    this.table.resetTable();
                    this.table.setTable();
                }, 0);
            });
        }else{
            Swal.fire('Error', error, 'error');
        }


    }

    async actionIcon(e, i, d){
        if(d === 'evidence'){
            var obj = this.state.visits[i];
            var id = obj.visitId;

            this.props.history.push({
                pathname: '/reports/visit/details/'+id,
                state: {
                    startDate: this.state.start_date,
                    endDate: this.state.end_date
                }
            });
        }else{
            this.getLocation(e, i, d);
        }



    }

    updateColumns(e, i){
        var columns = this.state.columns;
        columns[i].visible = e.target.checked;
        this.setState({columns: columns});
    }

    getLocation(e, i, d){
        var list = this.state.list[i];
        var index = list.findIndex(obj => obj.indexOf('map-marker/green/'+d) !== -1 );

        if(index !== -1){
            var name = list[0];
            var lat = parseFloat(list[index].split('/')[5]);
            var lng = parseFloat(list[index].split('/')[6]);

            this.modal_map.handleShow(lat, lng, name)
        }else {
            var name = list[0];
            var lat = parseFloat(list[2].split('/')[5]);
            var lng = parseFloat(list[2].split('/')[6]);

            this.modal_map.handleShow(lat, lng, name)
        }

    }

    async downloadEvidences(){
        if (this.state.list.length === 0) {
            return;
        }

        var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);
        var obj = {
            startDate: this.state.start_date,
            endDate: this.state.end_date
        };
        var date1 = this.state.start_date.replace(/-/g, "");
        var date2 = this.state.end_date.replace(/-/g, "");

        var res = await this.props.fetchRequest({
            api:'reports',
            method:'POST',
            url:'reports/visits-list/'+accountId,
            requireToken:true,
            obj:obj,
            modal:this.props.modal_loader,
            message_modal:'Descargando...',
            is_file:true
        });

        if(res !== undefined){
            await fileDownLoad('evidencias_'+date1+'_al_'+date2, ".xlsx", 'application/vnd.ms-excel', res);
        }
    }

    render(){
        const {t} = this.props;
        // El DatePicker de rsuite trae su propio calendario/textos ("Today",
        // días/meses) en inglés por defecto — IntlProvider lo traduce al
        // idioma actual de la app (i18next). Además, el mes del header del
        // calendario lo formatea rsuite con date-fns (no con moment, a pesar
        // de usar tokens estilo moment), así que necesita su propio
        // formatDate aparte para salir también en español.
        const isEnglish = this.props.i18n.language && this.props.i18n.language.startsWith('en');
        const rsuiteLocale = isEnglish ? enUS : esES;
        const formatDate = (date, formatStr) => isEnglish ?
            dateFnsFormat(date, formatStr)
            : dateFnsFormat(date, formatStr, {locale: dateFnsEsLocale});
        return (
            <IntlProvider locale={rsuiteLocale} formatDate={formatDate}>
            <Layout {...this.props}>
                <Grid fluid>
                    <Col xs={24}>
                        <h3 className="s-title-page">{t('screen.reports.'+this.state.filename)}</h3>
                    </Col>
                    <Col xs={24}>
                    <Panel className="panel-general" shaded>
                        <Col xs={24} sm={4}>
                            <ControlLabel className="s-table-titles">{t('screen.reports.absences.form.start_date')}</ControlLabel>
                            <DatePicker
                                format="DD/MM/YYYY"
                                value={this.state.start_date ? moment(this.state.start_date).toDate() : null}
                                onChange={(date)=>this.handleDateChange('start_date', date)}
                                cleanable={false}
                                oneTap
                                style={{width:'100%'}}
                                size="sm"
                            />
                        </Col>

                        <Col xs={24} sm={4}>
                            <ControlLabel className="s-table-titles">{t('screen.reports.absences.form.end_date')}</ControlLabel>
                            <DatePicker
                                format="DD/MM/YYYY"
                                value={this.state.end_date ? moment(this.state.end_date).toDate() : null}
                                onChange={(date)=>this.handleDateChange('end_date', date)}
                                cleanable={false}
                                oneTap
                                style={{width:'100%'}}
                                size="sm"
                            />
                        </Col>
                        <Col xs={24} sm={4} className="form-group">
                           <ControlLabel className="s-table-titles">{t('screen.reports.overtime.form.location')}</ControlLabel>
                            <select className="form-control form-control-sm" name="locationId"
                                id="location" value={this.state.locationId}
                                onChange={(e)=>this.handleChange(e)}
                                disabled={this.state.userType === 'client'? true : false}
                            >
                                <option value="all">{t('screen.reports.all')}</option>
                                {this.state.locations.map((loc, i)=>
                                    <option value={loc.id} key={i}>{loc.name}</option>
                                )}
                            </select>
                        </Col>

                        <Col xs={24} sm={4} style={{marginTop:30}}>
                            <Button className="s-btn-primary" onClick={(e)=>this.search(e, 'reports/visits')}>
                                {t('button.search')}
                            </Button>
                            <Button onClick={(e)=>this.props.history.goBack()} style={{marginLeft:8}}>
                                {t('button.return')}
                            </Button>
                        </Col>
                        <Col xs={24} sm={8} style={{marginTop:30, textAlign:'right', whiteSpace:'nowrap'}}>
                            <Dropdown title={t('general.table.export')} placement="bottomEnd" className="export-dropdown" style={{display:'inline-block'}}>
                                <Dropdown.Item disabled={this.state.list.length === 0} onClick={()=> this.state.list.length > 0 && this.table && this.table.triggerButton('buttons-excel')}>Excel</Dropdown.Item>
                                <Dropdown.Item disabled={this.state.list.length === 0} onClick={()=> this.state.list.length > 0 && this.table && this.table.triggerButton('buttons-pdf')}>PDF</Dropdown.Item>
                                <Dropdown.Item disabled={this.state.list.length === 0} onClick={this.downloadEvidences}>
                                    {t('button.download_evidences')}
                                </Dropdown.Item>
                            </Dropdown>
                            <Dropdown
                                title={<><Icon icon="columns" /> {t('general.table.columns')}</>}
                                placement="bottomEnd"
                                className="columns-dropdown"
                                style={{marginLeft:8, display:'inline-block'}}
                            >
                                {this.state.columns.map((c, i)=>(
                                    <Dropdown.Item key={i}>
                                        <label className="col-visibility-item" onClick={(e)=>e.stopPropagation()}>
                                            <input
                                                type="checkbox"
                                                checked={c.visible}
                                                onChange={(e)=>this.updateColumns(e, i)}
                                            /> {t('screen.reports.visit.columns.'+c.name)}
                                        </label>
                                    </Dropdown.Item>
                                ))}
                            </Dropdown>
                        </Col>
                        <Col xs={24}>
                            <TableList
                                {...this.props}
                                onRef={ref => this.table = ref}
                                columns={this.state.columns}
                                btnNew={false}
                                data={this.state.list}
                                actions={[]}
                                actionIcon={this.actionIcon}
                                screen={"visit"}
                                searching={false}
                                report={true}
                                table_title={[]}
                                filename={t('screen.reports.'+this.state.filename)}
                                scroll={true}
                                scrollY="calc(100vh - 340px)"
                                widths={this.state.columns.map(c => c.width)}
                                search={this.search}
                                downloadEvidences={this.downloadEvidences}
                            />
                        </Col>
                    </Panel>
                    </Col>
                </Grid>

                <ModalMap {...this.props} onRef={ref => this.modal_map = ref} />
            </Layout>
            </IntlProvider>
        )
    }
}

export default withTranslation('translations')(Visit);
